/**
 * @generated SignedSource<<8ae355941323cd934d51df699abae087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddSourceTagInput = {
  clientMutationId?: string | null;
  pageId: string;
  sourceId: string;
  key?: string | null;
  value?: string | null;
};
export type FunnelSourceCreateFormContainer_Mutation$variables = {
  input: AddSourceTagInput;
  connections: ReadonlyArray<string>;
};
export type FunnelSourceCreateFormContainer_MutationVariables = FunnelSourceCreateFormContainer_Mutation$variables;
export type FunnelSourceCreateFormContainer_Mutation$data = {
  readonly addSourceTag: {
    readonly sourceTag: {
      readonly id: string;
      readonly key: string | null;
      readonly value: string | null;
      readonly slug: string;
      readonly source: {
        readonly id: string;
        readonly name: string;
      };
      readonly pageUrl: string;
    };
  } | null;
};
export type FunnelSourceCreateFormContainer_MutationResponse = FunnelSourceCreateFormContainer_Mutation$data;
export type FunnelSourceCreateFormContainer_Mutation = {
  variables: FunnelSourceCreateFormContainer_MutationVariables;
  response: FunnelSourceCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SourceTag",
  "kind": "LinkedField",
  "name": "sourceTag",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Source",
      "kind": "LinkedField",
      "name": "source",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelSourceCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddSourceTagPayload",
        "kind": "LinkedField",
        "name": "addSourceTag",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelSourceCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddSourceTagPayload",
        "kind": "LinkedField",
        "name": "addSourceTag",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "sourceTag",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "SourceTagEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37313d44809790308959c4ed7a26b126",
    "id": null,
    "metadata": {},
    "name": "FunnelSourceCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelSourceCreateFormContainer_Mutation(\n  $input: AddSourceTagInput!\n) {\n  addSourceTag(input: $input) {\n    sourceTag {\n      id\n      key\n      value\n      slug\n      source {\n        id\n        name\n      }\n      pageUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "96dcbd2fd14f8a626119976fba9cadde";

export default node;
